/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PedestrianDevice
 */
export interface PedestrianDevice {
    /**
     * 
     * @type {string}
     * @memberof PedestrianDevice
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof PedestrianDevice
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PedestrianDevice
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof PedestrianDevice
     */
    networkId: number;
    /**
     * 
     * @type {string}
     * @memberof PedestrianDevice
     */
    hardwareSerialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PedestrianDevice
     */
    label?: string | null;
}

/**
 * Check if a given object implements the PedestrianDevice interface.
 */
export function instanceOfPedestrianDevice(value: object): value is PedestrianDevice {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('networkId' in value) || value['networkId'] === undefined) return false;
    if (!('hardwareSerialNumber' in value) || value['hardwareSerialNumber'] === undefined) return false;
    return true;
}

export function PedestrianDeviceFromJSON(json: any): PedestrianDevice {
    return PedestrianDeviceFromJSONTyped(json, false);
}

export function PedestrianDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PedestrianDevice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'networkId': json['networkId'],
        'hardwareSerialNumber': json['hardwareSerialNumber'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function PedestrianDeviceToJSON(json: any): PedestrianDevice {
    return PedestrianDeviceToJSONTyped(json, false);
}

export function PedestrianDeviceToJSONTyped(value?: PedestrianDevice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'networkId': value['networkId'],
        'hardwareSerialNumber': value['hardwareSerialNumber'],
        'label': value['label'],
    };
}

